/**
 * Native platform bootstrap for Hifz.
 *
 * Runs once at app boot from App.js. When the React bundle is loaded inside
 * a Capacitor WebView (iOS/Android), this configures the status bar, hides
 * the splash screen after first paint, and wires the hardware back button
 * to browser history navigation. In a plain browser, all of this is a
 * no-op — Capacitor.isNativePlatform() returns false and the helpers are
 * tree-shaken at runtime.
 */
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { App as CapacitorApp } from "@capacitor/app";

export const isNative = () => Capacitor.isNativePlatform();

export async function initNative() {
  if (!isNative()) return;

  // Match the dark navy header — no white flash on cold-start.
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#0F1B2D" });
  } catch (e) {
    // iOS 15+ doesn't allow setBackgroundColor; ignore silently.
    console.warn("StatusBar config:", e);
  }

  // Hide the splash screen once the React app has hydrated.
  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch (e) {
    console.warn("SplashScreen hide:", e);
  }

  // Hardware back button (Android) → browser history back, and if we're
  // already at the root, minimize the app instead of nuking the session.
  CapacitorApp.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else CapacitorApp.minimizeApp();
  });
}
